module.exports = __webpack_public_path__ + "b4f606d4e08ba6fcf3de70f5e34b52cb.pdf";